import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { ExpandingContent } from './ExpandingContent';
import styles from './styles/ShoppingWithLinks.scss';

function ShoppingWithLinksComponent({ shoppingWith }) {
    const links = get(shoppingWith, 'links.links') || [];

    if (!links.length) {
        return null;
    }

    return (
        <ExpandingContent
            expandingChildren={({ isExpanded }) =>
                isExpanded ? (
                    <ul className={styles.list}>
                        {links.map(({ url, label }) => (
                            <li key={url}>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.link}
                                    href={url}
                                >
                                    {label}
                                </a>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div />
                )
            }
        >
            {({ icon, expandingContent, onToggleExpanded }) => (
                <div className={styles.wrapper}>
                    <a className={styles.link} href="#" onClick={onToggleExpanded}>
                        {get(shoppingWith, 'links.title')} {icon}
                    </a>
                    {expandingContent}
                </div>
            )}
        </ExpandingContent>
    );
}

ShoppingWithLinksComponent.propTypes = {
    shoppingWith: PropTypes.object.isRequired,
};

export const ShoppingWithLinks = createFragmentContainer(ShoppingWithLinksComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithLinks_shoppingWith on ShoppingWith {
            links {
                title
                links {
                    url
                    label
                }
            }
        }
    `,
});
